import { Injectable, Renderer2, RendererFactory2 } from '@angular/core';
import { Subject } from 'rxjs';
import { UserService } from './user.service';

@Injectable({ providedIn: 'root' })
export class LockService {

    // time before lock screen in milliseconds
    public idleTime: number = 10 * 60 * 60 * 1000; 

    //show or hide the lock screen
    public isLockScreenActive: boolean = false;

    //array of render event listener
    renderEvents: any[] = [];

    isAppActive: boolean = true;

    private renderer: Renderer2;

    constructor(private userService: UserService,
                rendererFactory: RendererFactory2,
        ) {

        this.renderer = rendererFactory.createRenderer(null, null);

        //get global variable over the browser to detect if the screen is locked
        this.isLockScreenActive = localStorage.getItem('lockedScreen') && localStorage.getItem('lockedScreen') == 'true' ? true : false ;

        this.userService.currentUser.subscribe(user => {
            this.isLockScreenActive = this.isLockScreenActive && (user == null);
            if (!this.isLockScreenActive) {
                document.getElementsByTagName('body')[0].classList.remove("hide-v-scroll");
            }

            this.registerIdleEventListener();
        });

        //set global variable over the browser to detect if the user is using the app in any other tab
        localStorage.setItem('isAppActive', 'true');
        if(!this.isLockScreenActive){
            this.registerIdleEventListener();

        }
        
        if(this.isLockScreenActive){
            document.getElementsByTagName('body')[0].classList.add("hide-v-scroll");
        }

        let that = this;

        //check if the user focus on the app
        window.addEventListener('focus', (e) => {
                if(userService.currentUserValue == null && that.isLockScreenActive){
                    localStorage.setItem('lockedScreen', 'false');
                    that.refreshPage();
                    return;
                }
                if(userService.currentUserValue != null && !that.isLockScreenActive){
                    that.registerIdleEventListener();
                    localStorage.setItem('isAppActive', 'true');
                    that.isAppActive = true;
                }
        });

        // check when the user left the tab
        window.addEventListener('blur', () => {
                localStorage.setItem('isAppActive', 'false');
                that.isAppActive = false;
        });

        // subscribe on the storage to check when to lock screen
        window.addEventListener('storage', (e) => { 
            // if the lockscreen variable changed
            if(e.key == 'lockedScreen')
                that.isLockScreenActive = e.newValue == 'true' ? true : false ;
            
            if (!that.isLockScreenActive) {
                document.getElementsByTagName('body')[0].classList.remove("hide-v-scroll");
            }

            // if the app focused in other tab
            if(e.key == 'isAppActive')
            {
                if(e.newValue == 'true'  || !that.isAppActive){
                clearTimeout(that.timeOutO);
                that.destroyRenderEvents();
                }
                
            }
        });

    }

    // used to set the time interval
    timeOutO;

    // set the time interval to count when to lock screen
    setTimeOut() {
        clearTimeout(this.timeOutO);
        
        this.timeOutO = setTimeout(() => {
            if(this.userService.currentUserValue != null){
                this.isLockScreenActive = true;
                // set the global variable to lock screen
                localStorage.setItem('lockedScreen', 'true');
                this.timeOutO;
                // stop listen to the active events
                this.destroyRenderEvents();
                document.getElementsByTagName('body')[0].classList.add("hide-v-scroll");
            }
            
        }, this.idleTime)
    }

    registerIdleEventListener() {
        // make sure previous listeners are removed first
        this.destroyRenderEvents();

        this.setTimeOut()
        
        this.renderEvents = [
            this.renderer.listen('window', 'mousemove', (event) => {
                this.setTimeOut()
            }),
            this.renderer.listen('window', 'mousedown', (event) => {
                this.setTimeOut()
            }),

            this.renderer.listen('window', 'keypress', (event) => {
                this.setTimeOut()
            }),

            this.renderer.listen('window', 'DOMMouseScroll', (event) => {
                this.setTimeOut()
            }),

            this.renderer.listen('window', 'mousewheel', (event) => {
                this.setTimeOut()
            }),

            this.renderer.listen('window', 'touchmove', (event) => {
                this.setTimeOut()
            }),

            this.renderer.listen('window', 'MSPointerMove', (event) => {
                this.setTimeOut()
            })
        ]
    }

    destroyRenderEvents() {

        this.renderEvents.forEach(el => {
            el();
        })
    }
    refreshPage(){
        location.reload();
    }
}
